import {call} from "../backend/connectors/NodeConnector";
import {lgSetup} from "../backend/LgSetup";
import {getObjectFromCache, saveObjectToCache} from "./storage/DataCache";

export async function testDistanceCalculator() {
    let regionKey = "BADEN-WÜRTTEMBERG"
    await calculateDistances(regionKey, true).then((data) => {
            if (data.points.KARLSRUHE === undefined)
                throw Error("karlsruhe expected!")
            if (data.regionHash === undefined)
                throw Error("Missed hash")

        }
    )
}

export async function calculateDistances(regionKey, useMock) {
    let cachedObj = getObjectFromCache("ONEDAY", "Geo")
    if (cachedObj !== undefined && calcRegionHash(regionKey) === cachedObj["regionHash"]) return Promise.resolve(cachedObj)
    else {
        return calculateDistancesImpl(regionKey, useMock).then((data) => {
                saveObjectToCache("ONEDAY", "Geo", data)
                return data;
            }
        )
    }
}

function calcRegionHash(regionKey) {
    let ret = ""
    if (lgSetup.regions[regionKey] !== undefined)
        Object.keys(lgSetup.regions[regionKey].cities).forEach((cityKey) => {
                ret = ret + cityKey
            }
        )
    else
        ret = ret + regionKey
    return ret
}

async function calculateDistancesImpl(regionKey, useMock) {

    let body = {
        "trace": "false",
        "action": "ResolveGeo",
        "mock": useMock
    }
    let points = {}
    if (lgSetup.regions[regionKey] !== undefined)
        Object.keys(lgSetup.regions[regionKey].cities).forEach((cityKey) => {
                let city = lgSetup.cities[cityKey]
                //console.log(cityKey)
                let point = {}
                point.x = city["geoPoint"].x
                point.y = city["geoPoint"].y
                points[cityKey] = point
            }
        )
    else {
        let city = lgSetup.cities[regionKey]
        if (city !== undefined) {
            let point = {}
            point.x = city["geoPoint"].x
            point.y = city["geoPoint"].y
            points[regionKey] = point
        }
    }
    body.points = points
    let resp = await call(body)
    if (resp.status !== 200)
        throw Error("unexpected status: " + resp.status)
    let result = {
        geo: {
            ip: resp.data.geo.ip,
            address: resp.data.google.origin_addresses[0],
            country: resp.data.geo.country_name,
            region: resp.data.geo.region,
            city: resp.data.geo.city,
            y: resp.data.geo.latitude,
            x: resp.data.geo.longitude,
        },
        points: {}
    }

    let myArr = new Array()
    let i = 0
    if (lgSetup.regions[regionKey] !== undefined)
        Object.keys(lgSetup.regions[regionKey].cities).forEach((cityKey) => {

                let point = points[cityKey]
                if (point !== undefined) {
                    point.cityKey = cityKey
                    point.duration = resp.data.google.rows[0].elements[i].duration
                    point.address = resp.data.google.destination_addresses[i]
                    point.distance = resp.data.google.rows[0].elements[i].distance
                    result.points[cityKey] = point
                    i++
                    myArr.push(point)
                }
            }
        )
    else {
        let point = points[regionKey]
        if (point !== undefined) {
            point.cityKey = regionKey
            point.duration = resp.data.google.rows[0].elements[i].duration
            point.address = resp.data.google.destination_addresses[i]
            point.distance = resp.data.google.rows[0].elements[i].distance
            result.points[regionKey] = point
            i++
            myArr.push(point)
        }
    }
    myArr.sort((a, b) => ((a.duration === undefined || b.duration === undefined) ? 0 : a.duration.value - b.duration.value))
    result.pointsSorted = myArr
    result["regionHash"] = calcRegionHash(regionKey)
    return result
}

